import { Component, OnInit, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MbCommunication, MbExpandableText } from '@am/moebius';
// import { ICustomBanner } from '@core/models/banners';

@Component({
    selector: 'custom-banner',
    templateUrl: './custom-banner.component.html',
    styleUrls: ['./custom-banner.component.scss'],
    imports: [MbCommunication, MbExpandableText],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomBannerComponent implements OnInit {
  @Input()
  data: any;

  public alertDismissed: boolean;

  constructor() {}

  ngOnInit() {
    this.alertDismissed = false;
  }

  public onCloseAlert() {
    this.alertDismissed = true;
  }
}
